<div style="padding:20px;"> 
    <div class="row left-al">
        <div class="col-sm-4"></div>
        <div class="col-sm-4"></div>
        <div class="col-sm-4" style="display: flex; align-items: center; justify-content: flex-end;">
        <button [useExistingCss]="true" printSectionId="print-Id" ngxPrint style="border: unset !important; background-color:#ffffff;" >
            <a > <img style="cursor: pointer;height: 17px; width: 18px;" src="assets/images/topprint.png"></a>
          </button> &nbsp;&nbsp;
          <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <i class="fa fa-times" style="font-size:13px;float:right; cursor: pointer;"></i>
          </button>
        </div>
    </div>
    <div id="print-Id">
   <div style="border: 1px solid black !important; padding:10px !important; width:400px !important;">
        <div class="row cntr" style="width: 100%; display: flex; white-space: nowrap;">
        <div class="col-sm-5" style="text-align: center; width: 40%;">
            <img style="height: 90px;width: 105px;" src="assets/images/iconplaceholder.jpg">
        </div>
        <div class="col-sm-4" style="width: 40%;">
            <!-- <img  style="height: 90px; width: 105px;" src="assets/images/qrcode.png"> -->
            <!-- <qrcode [qrdata]="'Hi'" [width]="256" [errorCorrectionLevel]="'M'"></qrcode> -->
            <!-- <qr-code [value]="'Tesst'" size="350"></qr-code> -->
            <!-- <qr-code [value]="'https://www.freakyjolly.com/'"></qr-code> -->
            <qr-code [value]="qrdata" size="150"></qr-code>
        </div>
        
        <div class="col-sm-3" style="width: 20%;">
           
        </div>
    </div>
    <div class="row" style="width: 100%; display: flex; white-space: nowrap;">
        <div class="col-sm-4" style="width: 40%;">
            <ng-container *ngFor="let ls of screenData">
                <div class="id_title" *ngIf="ls.ctrl_id == 'pgmember_type_desc'">
                    {{ls.label_desc}}
                </div>
                
                <div class="id_title" *ngIf="ls.ctrl_id == 'shg_id' && data.data.shg_id">
                    {{ls.label_desc}}
                </div>
                <div class="id_title" *ngIf="ls.ctrl_id == 'pgmember_id'">
                    {{ls.label_desc}}
                </div>
            <div class="id_title" *ngIf="ls.ctrl_id == 'member_name'">
                {{ls.label_desc}}
            </div>
            <div class="id_title" *ngIf="ls.ctrl_id == 'fh-name'">
                {{ls.label_desc}}
            </div>

            <div class="id_title" *ngIf="ls.ctrl_id == 'village_name'">
                {{ls.label_desc}}
            </div>
            <div class="id_title" *ngIf="ls.ctrl_id == 'gp_name'">
                {{ls.label_desc}}
            </div>
            <div class="id_title" *ngIf="ls.ctrl_id == 'pg_name'">
                {{ls.label_desc}}
            </div>
            <div class="id_title" *ngIf="ls.ctrl_id == 'mobile_no'">
                {{ls.label_desc}}
            </div>
            <div class="id_title" *ngIf="ls.ctrl_id == 'mobile_no_alternative'">
                {{ls.label_desc}}
            </div>
            
        </ng-container>
        </div>
        <div class="col-sm-8" style="width: 60%;">
            <!-- <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.pgmember_type_desc}}
              </div>
              <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.pg_name}}
            </div>
            <div class="id_data" *ngIf="data.data.shg_id">
                <span>:</span>&nbsp;&nbsp;{{data.data.shg_id}}
            </div>
            <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.pgmember_id}}
            </div> -->
            <div class="id_data">
              <span>:</span>&nbsp;&nbsp;{{data.data.pgmember_name}}
            </div>
            <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.fatherhusband_name}}
            </div>
            <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.village_desc}}
            </div>
            <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.panchayat_desc}}
            </div>
            <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.pg_name}}
            </div>
            <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.mobile_no_active}}
            </div>
            <div class="id_data">
                <span>:</span>&nbsp;&nbsp;{{data.data.mobile_no_alternative}}
            </div>
        </div>
    </div>
</div>
</div>
</div>
